// Generated from src/img/svg/fvicon.svg

export const Fvicon = (props) => {
  return (
    <svg viewBox="0 0 60 60" {...props}>
      <circle cx="22.5" cy="35.5" r="3" style={{ fill: "#333" }} />
      <path d="m36.5 43.5 2 3h-17l2-3z" style={{ fill: "#333" }} />
      <circle cx="36.5" cy="35.5" r="3" style={{ fill: "#333" }} />
      <path
        d="M19.5 21.59v-3.35a3.734 3.734 0 0 1 3.74-3.74h12.52a3.734 3.734 0 0 1 3.74 3.74v3.35a3.91 3.91 0 0 1-3.91 3.91H23.41a3.91 3.91 0 0 1-3.91-3.91"
        style={{ fill: "#333" }}
      />
      <path
        d="M30.5.5a29 29 0 1 0 29 29 28.995 28.995 0 0 0-29-29m10.623 50-1.423-2H20.14l-1.361 2H14.5l6.76-8.7a8.04 8.04 0 0 1-4.76-7.33V13.44a4.94 4.94 0 0 1 4.94-4.94h16.12a4.94 4.94 0 0 1 4.94 4.94v21.03a8.03 8.03 0 0 1-4.19 7.05l7.19 8.98Z"
        style={{ fill: "#333" }}
      />
      <path d="M0 0h60v60H0z" style={{ fill: "none" }} />
    </svg>
  );
};
